const defaultState = {
  data: [],
  loading: false,
  error: false,
};

const campaigns = function (state = defaultState, action) {
  let data, target;

  switch (action.type) {
    case 'SET_CAMPAIGNS':
      return { ...state, data: action.data };

    case 'UPDATE_CAMPAIGN':
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data[target] = action.data;
      }
      return { ...state, data };

    case 'REMOVE_CAMPAIGN':
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data.splice(target, 1);
      }
      return { ...state, data };

    case 'INSERT_CAMPAIGN':
      return { ...state, data: [...state.data, action.data] };

    case 'SET_CAMPAIGNS_LOADING':
      return {
        ...state,
        loading: action.data,
      };

    case 'SET_CAMPAIGNS_ERROR':
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default campaigns;
